import { Button, useDisclosure } from '@chakra-ui/react'
import { generatePath, useNavigate } from 'react-router'
import { Paths } from 'src/constants/paths'
import {
  useAuthenticatedAccount,
  usePermission,
  useSelectedTrial,
} from 'src/features/auth/context'
import { PERMISSIONS } from 'src/lib/permission'

import { ExplanationDetail } from '../../types'
import { isPartner } from '../../utils/isPartner'
import { ExplanationStartReAgreementConfirmModal } from '../ExplanationStartReAgreementConfirmModal/ExplanationStartReAgreementConfirmModal'

type Props = {
  explanation: ExplanationDetail
}

export const ExplanationStartReAgreementButton: React.FC<Props> = ({
  explanation,
}) => {
  const { selectedTrial } = useSelectedTrial()

  const {
    account: { selectedTrialHospitalUid },
  } = useAuthenticatedAccount()

  const { hasPermission } = usePermission()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const navigate = useNavigate()

  if (!hasPermission(PERMISSIONS.Explanation_Edit)) return null
  if (!explanation.isRequiredReAgreement) return null
  if (
    selectedTrialHospitalUid &&
    isPartner(explanation, selectedTrialHospitalUid)
  )
    return null

  return (
    <>
      <Button onClick={onOpen}>再同意実施</Button>
      <ExplanationStartReAgreementConfirmModal
        status={explanation.latestRevision.status}
        candidateId={explanation.patient.candidateId}
        hasBeforeReservation={
          explanation.trialPatient.reservations.filter(
            r => r.timeStatus === 'Upcoming',
          ).length > 0
        }
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={() => {
          navigate(
            generatePath(Paths.ExplanationAddReAgreement, {
              trialUid: selectedTrial.uid,
              explanationUid: explanation.uid,
            }),
          )
        }}
      />
    </>
  )
}
